import urls from '@/legacy/config/env';
import api from '@/legacy/services/api';
import type { ApiProfileDto, UpdateProfileDto } from '../types';

export const fetchProfile = async (): Promise<ApiProfileDto> => {
	const response = await api.get<ApiProfileDto>(urls.profile.getProfile);
	return response.data;
};

export const updateProfile = async (data: UpdateProfileDto): Promise<void> => {
	await api.patch(urls.profile.updateProfile, data);
};

export const updateProfileImage = async (file: File): Promise<void> => {
	const formData = new FormData();
	formData.append('file', file);

	await api.put(urls.profile.changeAvatar, formData);
};
